import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row"
}
const _hoisted_2 = { class: "col-12 col-lg-4" }
const _hoisted_3 = { class: "col-12 col-lg-8" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"15px","color":"var(--bs-dark)"} }, " کد رهگیری حواله: ", -1)
const _hoisted_6 = { style: {"font-size":"15px","color":"var(--bs-primary)"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_windows_10_loading = _resolveComponent("windows-10-loading")!
  const _component_pre_order_price_box = _resolveComponent("pre-order-price-box")!
  const _component_pre_order_steps = _resolveComponent("pre-order-steps")!
  const _component_mobile_invoice_success = _resolveComponent("mobile-invoice-success")!
  const _component_desktop_invoice_success = _resolveComponent("desktop-invoice-success")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.status === 'loading')
      ? (_openBlock(), _createBlock(_component_windows_10_loading, {
          key: 0,
          label: "در حال پردازش ..."
        }))
      : _createCommentVNode("", true),
    (_ctx.status === 'success' || _ctx.response)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.breakpoints.isDesktop)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_pre_order_price_box, {
                    toman: _ctx.response.total,
                    tether: _ctx.response.amount,
                    reverse: ""
                  }, null, 8, ["toman", "tether"]),
                  _createVNode(_component_pre_order_steps, {
                    list: _ctx.response.state_list
                  }, null, 8, ["list"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.breakpoints.isMobile)
              ? (_openBlock(), _createBlock(_component_mobile_invoice_success, {
                  key: 0,
                  date: _ctx.response.done_date.split(' ')[0],
                  time: _ctx.response.done_date.split(' ')[1],
                  items: [
          {
            title: 'مقدار ارسالی',
            value: `${_ctx.response.amount} تتر`,
            valueStyle: 'font-family: IRANSansX',
          },
          {
            title: 'نرخ',
            value: `${Number(_ctx.response.rate).toLocaleString()} تومان`,
          },
          {
            title: 'کارمزد حواله بانکی',
            value: `${_ctx.response.settle_fee.toLocaleString()} تومان`,
          },
          {
            title: 'مبلغ دریافتی',
            value: `${Number(_ctx.response.final).toLocaleString()} تومان`,
          },
          {
            title: 'حساب مقصد',
            value: `
         <img src='${_ctx.response.bank_logo}' width='20' height='20' alt='${
              _ctx.response.bank
            }'>
        ${_ctx.response.ir_num.slice(0, 5)}***${_ctx.response.ir_num.slice(-6)}`,
            valueStyle: 'font-family: IRANSansX; direction: ltr;',
          },
          {
            title: 'زمان تقریبی دریافت حواله',
            value: `${_ctx.response.settle_date.split(' ')[0]} ساعت ${
              _ctx.response.settle_date.split(' ')[1]
            }`,
          },
        ]
                }, {
                  bottom: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.response.settle_msg), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["date", "time", "items"]))
              : (_ctx.breakpoints.isDesktop)
                ? (_openBlock(), _createBlock(_component_desktop_invoice_success, {
                    key: 1,
                    items: [
          {
            title: 'مقدار ارسالی',
            value: `${_ctx.response.amount} تتر`,
            copy: false,
            valueStyle: 'font-weight: 500; font-family: IRANSansX',
          },
          {
            title: 'نرخ',
            copy: false,
            value: `${Number(_ctx.response.rate).toLocaleString()} تومان`,
            valueStyle: 'font-weight: 500;',
          },
          {
            title: 'کارمزد حواله بانکی',
            copy: false,
            value: `${_ctx.response.settle_fee.toLocaleString()} تومان`,
            valueStyle: 'font-weight: 500;',
          },
          {
            title: 'مبلغ دریافتی',
            copy: false,
            value: `${Number(_ctx.response.final).toLocaleString()} تومان`,
            valueStyle: 'font-weight: bold;',
          },
          {
            title: 'حساب مقصد',
            value: `${_ctx.response.ir_num}|${_ctx.response.bank_logo}|${_ctx.response.bank}`,
            valueStyle:
              'font-family: IRANSansX; direction: ltr; font-weight: 500;',
          },
          {
            title: 'زمان تقریبی دریافت حواله',
            value: `${_ctx.response.settle_date.split(' ')[0]} ساعت ${
              _ctx.response.settle_date.split(' ')[1]
            }`,
            valueStyle: 'font-weight: 500;',
          },
          {
            title: 'کد رهگیری حواله',
            value: _ctx.response.settle_msg,
            valueStyle: 'font-weight: 500;',
          },
        ]
                  }, null, 8, ["items"]))
                : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}